import React from "react";
import { Carousel, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/logo-evo.png";

const ROUTES = {
  live: "/live",
  create: "/create-video", // ✅ CORRECTION ICI UNIQUEMENT
  upload: "/upload/video",
};

function UploadTabs() {
  return (
    <div className="mt-4">
      <Carousel>
        {/* Slide 1 : Live */}
        <Carousel.Item>
          <div
            className="d-flex flex-column justify-content-center align-items-center bg-dark"
            style={{ height: 400 }}
          >
            <img
              src={logo}
              alt="EVO Logo"
              style={{
                maxHeight: 150,
                marginBottom: 20,
                borderRadius: "50%",
                objectFit: "cover",
                backgroundColor: "white",
              }}
            />
            <h3 className="text-light">🎥 Démarrer un Live</h3>
            <p className="text-light">Partage ton moment en direct</p>
            <Button as={Link} to={ROUTES.live} variant="danger" size="lg">
              Démarrer le Live
            </Button>
          </div>
        </Carousel.Item>

        {/* Slide 2 : Créer une vidéo */}
        <Carousel.Item>
          <div
            className="d-flex flex-column justify-content-center align-items-center bg-dark"
            style={{ height: 400 }}
          >
            <img
              src={logo}
              alt="EVO Logo"
              style={{
                maxHeight: 150,
                marginBottom: 20,
                borderRadius: "50%",
                objectFit: "cover",
                backgroundColor: "white",
              }}
            />
            <h3 className="text-light">🎬 Créer une Vidéo</h3>
            <p className="text-light">
              Enregistre directement depuis l’application
            </p>
            <Button as={Link} to={ROUTES.create} variant="primary" size="lg">
              Créer une Vidéo
            </Button>
          </div>
        </Carousel.Item>

        {/* Slide 3 : Galerie */}
        <Carousel.Item>
          <div
            className="d-flex flex-column justify-content-center align-items-center bg-dark"
            style={{ height: 400 }}
          >
            <img
              src={logo}
              alt="EVO Logo"
              style={{
                maxHeight: 150,
                marginBottom: 20,
                borderRadius: "50%",
                objectFit: "cover",
                backgroundColor: "white",
              }}
            />
            <h3 className="text-light">📤 Importer depuis la Galerie</h3>
            <p className="text-light">
              Sélectionne une vidéo existante de ton appareil
            </p>
            <Button as={Link} to={ROUTES.upload} variant="success" size="lg">
              Télécharger une Vidéo
            </Button>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default UploadTabs;
